import { useMemo } from 'react';
import { useListContext } from 'ui/listLegacy';
import { Footer, ItemCount } from 'ui/listLegacy/styled';
import { Checkbox } from 'ui/checkboxV2';
import { useTranslation } from '../../../hooks';

type FooterProps = {
  selectedCount: number;
  setSelectedFields: (newSelectedFields: string[]) => void;
};

export const FieldsListFooter = ({ selectedCount, setSelectedFields }: FooterProps) => {
  const { t } = useTranslation();
  const { totalCount, items = [] } = useListContext();
  const allItemIds = useMemo(() => items.map((item) => item.id), [items]);

  const checkboxStatus = useMemo(() => {
    if (selectedCount === 0) {
      return false;
    }
    if (selectedCount === totalCount) {
      return true;
    }
    return 'indeterminate';
  }, [selectedCount, totalCount]);

  const handleBulkCheckboxChecked = () => {
    // Select everything if fields are not or are partially selected
    if (!checkboxStatus || checkboxStatus === 'indeterminate') {
      setSelectedFields(allItemIds);
    } else {
      setSelectedFields([]);
    }
  };

  return (
    <Footer>
      <Checkbox
        data-test={`checkbox-bulkselect`}
        id={`checkbox-bulkselect`}
        status={checkboxStatus}
        label={
          <ItemCount>
            {t('modal.exportToCSV.footerSelectedText', { selectedCount, totalCount })}
          </ItemCount>
        }
        setChecked={handleBulkCheckboxChecked}
      />
    </Footer>
  );
};
